import { Col, EventHandler, InputField, Label, ModalPopup, PopupDialogbox, PrimaryButton, ReactSelectBox, Row, SofturaTable, SwitchToggle, Tabs } from "client/CommonComponents"
import excel from '../../../../assets/images/Excel.svg'
import './ApprovalHierarchy.scss'
import AddPosition from "./AddPosition/AddPosition-container"
import permissions, { isAuthorized } from "client/utils/Permissions"
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup"
import Hierarchy from "./Hierarchy"
import AdditionalApprovers from "./AdditionalApprovers"

const ApprovalHierarchy = ({
    regionOptions,
    marketOptions,
    approvalHierarchyColumns,
    additionalApproversColumns,
    handleChangeEditHierarchy,
    handleClickAddNewPosition,
    showAddNewPositionPopup,
    handleClickAddNewTitle,
    showAddNewTitlePopup,
    setShowAddNewTitlePopup,
    showMarket,
    showTableAndButtons,
    handleRegionOnChange,
    selectedRegion,
    selectedMarket,
    handleMarketOnChange,
    hierarchyTableTemp,
    additionalApprovalTableTemp,
    showGrid,
    isEditHierarchy,
    addNewTitleOnClick,
    titleOnChange,
    titleValue,
    hideDialog,
    Popupcontent,
    titleError,
    onExportExcel,
    setSelectedAddtitle,
    selectedAddTitle,
    setSelectedAddPosition,
    selectedAddPosition,
    setAddPositionError,
    addPositionError,
    setAddTitleError,
    addtitleError,
    onAddNewTitleClick,
    isEditPosition,
    showDeletePopup,
    closeAddAndEditPopup,
    onClearClick,
    selectedKey,
    handleLinkClick }: any) => {

    const tabItems = [
        {
            itemKey: "hierarchy",
            headerText: "Hierarchy",
            content: <Hierarchy hierarchyTableTemp={hierarchyTableTemp} approvalHierarchyColumns={approvalHierarchyColumns} showGrid={showGrid} />
        },
        {
            itemKey: "additionalApprovers",
            headerText: "Additional Approvers",
            content: <AdditionalApprovers additionalApprovalTableTemp={additionalApprovalTableTemp} additionalApproversColumns={additionalApproversColumns} showGrid={showGrid} />
        }
    ];
    return (
        <>
        <div className="row">
                <div className='penalityHeader margin-bottom-heading'>
                    <p className='headingText pull-left'>View Hierarchy</p>
                </div>
            </div>
        <Row>
            <Col xs={12} sm={12} md={5} lg={3} className='mb-3 mb-lg-0 mb-md-0 mb-sm-0'>
                <Label data-attribute="ApprovalHierarchy_Default_Label">Region</Label>
                <ReactSelectBox
                    placeholder='Select Region'
                    options={regionOptions}
                    onChange={(e: any) => handleRegionOnChange(e)}
                    isSearchable={true}
                    value={selectedRegion ? selectedRegion : ''}  data-attribute="ApprovalHierarchy_Default_SearchSelectBox" />
            </Col>
            {showMarket && selectedRegion ?
                <Col xs={12} sm={12} md={5} lg={3} className='mb-3 mb-lg-0 mb-md-0 mb-sm-0'>
                    <Label data-attribute="ApprovalHierarchy_Default_Label_2">Market</Label>
                    <ReactSelectBox
                         placeholder='Select Market'
                        options={marketOptions}
                        isSearchable={true}
                        value={selectedMarket ? selectedMarket : ''}
                        onChange={(e: any) => handleMarketOnChange(e)}  data-attribute="ApprovalHierarchy_Default_SearchSelectBox_2" />
                </Col>
                : null}
                {selectedRegion ?
                    <Col xs={12} sm={12} md={2} lg={3} className='clearfilters_approvalscr'>
                        <div className="pull-right ">
                            <PrimaryButton
                                text="Clear Filters"
                                className="pull-right"
                                onClick={onClearClick}
                             data-attribute="ApprovalHierarchy_Default_Button" />
                        </div>
                    </Col>
                    : null}
            {showTableAndButtons ?
                <Col>
                    <div className='mb-1 top-section approval-hierarchy'>
                        <div className='clearfix mt-3 mb-3'>
                            <p className='pull-left mt-3'>HIERARCHY: {marketOptions?.length == 1 ? selectedRegion?.label?.toUpperCase() : selectedMarket?.label?.toUpperCase()}</p>
                            <div className='btn-block-approvalhierarchy pull-right mt-sm-0 mt-2'>
                                {isAuthorized(permissions?.CreateEditHierarchy) ?
                                    <>
                                        <SwitchToggle className="mt-2" checked={isEditHierarchy} onChange={handleChangeEditHierarchy}  data-attribute="ApprovalHierarchy_Default_SwitchToggle" /><span className="st-text">Edit Hierarchy</span>
                                    </>
                                    : null}
                                <div className={`excel-section-approvalhierarchy mt-1 ${hierarchyTableTemp.current?.length ? "" : "disable-export-excel"}`}>
                                        <EventHandler onEvent={(e: any) => { onExportExcel(e) }} data-attribute="ApprovalHierarchy_Default_EventHandler">
                                        <img src={excel} alt='excel' />
                                    </EventHandler>
                                </div>
                                {(isAuthorized(permissions?.CreateEditHierarchy) && isEditHierarchy) ?
                                    <>
                                        <PrimaryButton text='Add New Position' className={'me-2'} onClick={handleClickAddNewPosition}  data-attribute="ApprovalHierarchy_Default_Button_2" />
                                        <PrimaryButton text='Add New Title' className={'me-0'} onClick={handleClickAddNewTitle}  data-attribute="ApprovalHierarchy_Default_Button_3" />
                                    </>
                                    : null}
                            </div>
                        </div>
                        <Tabs
                            tabItems={tabItems}
                            className='approval-dashboard-tab'
                            selectedKey={selectedKey}
                            handleLinkClick={handleLinkClick}
                         data-attribute="ApprovalHierarchy_Default_Tabs" />
                        {/* <div className={`pe-0 ${hierarchyTableTemp?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                            {showGrid ?
                                <SofturaTable
                                    data={hierarchyTableTemp.current ?? []}
                                    columns={approvalHierarchyColumns}
                                    sort={false}
                                    pagination={false}
                                    globalSearch={false}
                                    fixedHeader={true}
                                    className="approvalHierarchy-grid"
                                 data-attribute="ApprovalHierarchy_Default_Grid" />
                                : null}
                        </div> */}
                        {
                            showAddNewPositionPopup ?
                                <ModalPopup
                                    ShowModalPopupFooter={true}
                                    ModalPopupTitle={isEditPosition ? "EDIT POSITION" : "ADD NEW POSITION"}
                                    ModalPopupType="small"
                                    FooterSecondaryBtnTxt="Cancel"
                                    FooterPrimaryBtnTxt= {isEditPosition ? "Save" : "Add"}
                                    closeModalPopup={() => closeAddAndEditPopup()}
                                    PrimaryBtnOnclick={() => onAddNewTitleClick()}
                                    SecondryBtnOnclick={() => closeAddAndEditPopup()}
                                    ModalPopupName="AddPosition-Alert"
                                 data-attribute="ApprovalHierarchy_Default_ModalPopup">
                                    <AddPosition
                                        setSelectedAddtitle={setSelectedAddtitle}
                                        selectedAddTitle={selectedAddTitle}
                                        setSelectedAddPosition={setSelectedAddPosition}
                                        selectedAddPosition={selectedAddPosition}
                                        hierarchyTableTemp={hierarchyTableTemp}
                                        additionalApprovalTableTemp={additionalApprovalTableTemp}
                                        isAdditionalApprover={selectedKey === "additionalApprovers"}
                                        setAddPositionError={setAddPositionError}
                                        addPositionError={addPositionError}
                                        setAddTitleError={setAddTitleError}
                                        addtitleError={addtitleError}
                                        isEditPosition={isEditPosition} />
                                </ModalPopup> : <></>
                        }
                        {
                            showAddNewTitlePopup ?
                                <ModalPopup
                                    ShowModalPopupFooter={true}
                                    ModalPopupTitle="ADD NEW TITLE"
                                    ModalPopupType="small"
                                    FooterSecondaryBtnTxt="Cancel"
                                    FooterPrimaryBtnTxt="Add"
                                    closeModalPopup={() => setShowAddNewTitlePopup(false)}
                                    PrimaryBtnOnclick={(e: any) => addNewTitleOnClick(e)}
                                    SecondryBtnOnclick={() => setShowAddNewTitlePopup(false)}
                                    ModalPopupName="AddTitle-Alert"
                                 data-attribute="ApprovalHierarchy_Default_ModalPopup_2">
                                    <Label required data-attribute="ApprovalHierarchy_Default_Label_3">Title</Label>
                                    <InputField
                                        className={titleError ? 'controlValidation' : ''}
                                        onChange={(e: any) => { titleOnChange(e) }}
                                        value={titleValue ? titleValue : ''}
                                        placeholder="Enter Title"  data-attribute="ApprovalHierarchy_Default_Input" />
                                    {titleError?.length ?
                                        <p className='validMessage'>{titleError}</p> : null}
                                </ModalPopup> : <></>
                        }
                        {showDeletePopup ?
                            <PopupDialogbox
                                hideDialog={!Popupcontent.isDialogVisible}
                                onDismiss={hideDialog}
                                Popupcontent={Popupcontent}
                                popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                                popupPrimarybtnOnclick={Popupcontent?.popupPrimarybtnOnclick}  data-attribute="ApprovalHierarchy_Default_PopupDilalogBox" />
                            :
                            <></>}
                    </div>
                </Col>
                : null
            }
            <CompleteConfirmationPopup
                hideDialog={hideDialog}
                onDismiss={Popupcontent?.popupOutlinebtnOnclick}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={Popupcontent?.popupPrimarybtnOnclick}
            />
        </Row>
        </>
    )
}

export default ApprovalHierarchy